module.exports = __webpack_public_path__ + "img/number1.46010c94.svg";